var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 40 40",
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m31.6654 6.66699h-23.33337c-2.76142 0-5 2.23858-5 5.00001v16.6667c0 2.7614 2.23858 5 5 5h23.33337c2.7614 0 5-2.2386 5-5v-16.6667c0-2.76143-2.2386-5.00001-5-5.00001z",
    fillOpacity: 0.35,
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.33203 33.3337h9.99997v-8.3334c0-.884-.3512-1.7319-.9763-2.357s-1.4729-.9763-2.357-.9763h-11.66667v6.6667c0 1.326.52679 2.5978 1.46447 3.5355s2.20945 1.4645 3.53553 1.4645z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.6663 21.6666c-.3296 0-.6517-.0978-.9258-.281-.274-.1831-.4875-.4434-.6137-.7479-.1261-.3045-.1591-.6395-.0948-.9628.0643-.3232.223-.6202.456-.8533l8.3333-8.3333c.1538-.1592.3377-.2861.541-.3735.2033-.0873.422-.13332.6433-.13524.2213-.00193.4408.04024.6456.12404.2049.0838.3909.2076.5474.364.1565.1565.2803.3426.3641.5474.0838.2049.126.4243.124.6456-.0019.2213-.0479.44-.1352.6434-.0874.2033-.2143.3872-.3735.541l-8.3334 8.3333c-.3124.3126-.7363.4882-1.1783.4883z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.9996 16.6667c-.4419-.0001-.8658-.1758-1.1783-.4884l-3.3333-3.3333c-.233-.2331-.3917-.53-.456-.8533-.0643-.3232-.0313-.6583.0948-.9628.1262-.3045.3397-.5648.6137-.7479.2741-.1831.5962-.2809.9258-.281h3.3333c.4421 0 .866.1756 1.1786.4882.3125.3125.4881.7364.4881 1.1785v3.3333c.0001.3296-.0976.6518-.2806.926-.183.2741-.4432.4878-.7477.614-.2022.0843-.4193.1274-.6384.1267z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.8d0cb4fbe3637d37c14b8b57f0b15512.svg";
export { ForwardRef as ReactComponent };